import {Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MapSummaryApiService} from '../../../services/map/map-summary-api/map-summary-api.service';
import {DataCacheApiService} from '../../../services/map/data-cache-api/data-cache-api.service';
import {takeWhile} from 'rxjs/operators';
import {MapService} from '../../../services/map/map/map.service';
import {AcTabsComponent} from 'ac-infra';

@Component({
  selector: 'nothing-selected-summary',
  templateUrl: './nothing-selected-summary.component.html',
  styleUrls: ['./nothing-selected-summary.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class NothingSelectedSummaryComponent implements OnInit, OnDestroy {

  @ViewChild('summaryTabs', {static: false}) summaryTabs: AcTabsComponent;

  constructor(private mapSummaryApi: MapSummaryApiService,
              private dataCacheApiService: DataCacheApiService,
              private mapService: MapService) {
  }

  nodesTotal: any;
  nodesDistribution: any;
  peerConnectionsTotal: any;
  peerConnectionsDistribution: any;
  connectionsTotal: any;
  connectionsDistribution: any;
  dataReady = false;
  activeTabId;
  testRouteObservable;
  summaryRefreshObservable;

  ngOnInit(): void {
    this.testRouteObservable = this.mapService.onTestRoute().subscribe(() => {
      this.summaryTabs.defaultTabId = 'test-route-tab';
    });

    this.summaryRefreshObservable = this.mapService.onRefreshSummary().subscribe(() => {
      this.initializeDevicesStatusStatistics();
    });

    this.dataCacheApiService.getDataReady().pipe(takeWhile(() => this.dataReady === false)).
    subscribe(x => {
      if (x === true) {
        this.dataReady = true;
        this.initializeDevicesStatusStatistics();
      }
    });
  }

  tabSelectHandler(tab): void {
    this.activeTabId = tab.id;
  }

  private initializeDevicesStatusStatistics(): void {
    this.mapSummaryApi.getNodesTotalNew((fetchedNodesTotalDistribution) => {
      this.nodesTotal = fetchedNodesTotalDistribution;
    }, this.dataCacheApiService.getNodes());
    this.mapSummaryApi.getNodesDistributionNew((fetchedNodesDistribution) => {
      this.nodesDistribution = fetchedNodesDistribution;
    }, this.dataCacheApiService.getNodes());

    this.mapSummaryApi.getPeerConnectionsTotalNew((fetchedTotalPeerConnections) => {
      this.peerConnectionsTotal = fetchedTotalPeerConnections;
    }, this.dataCacheApiService.getPcons());
    this.mapSummaryApi.getPeerConnectionsDistributionNew((fetchedPeerConnectionsDistribution) => {
      this.peerConnectionsDistribution = fetchedPeerConnectionsDistribution;
    }, this.dataCacheApiService.getPcons());

    this.mapSummaryApi.getConnectionsTotalNew((fetchedTotalConnections) => {
      this.connectionsTotal = fetchedTotalConnections;
    }, this.dataCacheApiService.getConnections());
    this.mapSummaryApi.getConnectionsDistributionNew((fetchedConnectionsDistribution) => {
      this.connectionsDistribution = fetchedConnectionsDistribution;
    }, this.dataCacheApiService.getConnections());
  }

  ngOnDestroy(): void {
    this.testRouteObservable.unsubscribe();
    this.summaryRefreshObservable.unsubscribe();
  }
}
